export const BVTracking = `// our namespace
var BV = BV || {};

BV.tracking = (function () {
  var timerMap = {};

  function _startTimerForKey(key) {
    var d = new Date();
    timerMap[key] = d.getTime();
  }

  function _stopAndTrackTimerForKey(key, category, variable, label) {
    //console.log("Timer will be stopped for key: " + key);
    var d = new Date();
    var oldTimerValue = timerMap[key];
    if (oldTimerValue) {
      if (category === undefined || category == null || category == '') {
        category = 'none';
      }
      if (variable === undefined || variable == null || variable == '') {
        variable = '';
      }
      if (label === undefined || label == null) {
        label = '';
      }
      var timerDifference = d.getTime() - oldTimerValue;
      delete timerMap[key];
      _trackTiming(category, variable, label, timerDifference);
      return timerDifference;
    } else {
      return 0;
    }
  }

  function _trackTiming(category, variable, label, value) {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'trackTiming',
        category: category,
        variable: variable,
        label: label,
        value: value,
      });
    } else {
      console.log(
        'clientSideTimingAction: ' +
          category +
          '\t' +
          variable +
          '\t' +
          label +
          '\t' +
          value
      );
    }
  }

  // we use this to assign each hit/session with a unique id, to be able to calculate event counts
  // in google data studio
  function _getUniqueId() {
    return new Date().getTime() + '.' + Math.random().toString(36).substring(5);
  }

  function _trackAction(
    category,
    action,
    label,
    value,
    notCountAsInteraction,
    callback
  ) {
    // GA seems to require to provide a category, so we use a default one if none is specified
    if (category === undefined || category == null || category == '') {
      category = 'none';
    }
    if (notCountAsInteraction === undefined) {
      // by default, we assume an interaction with an event, i.e., we do not count a bounce if at least one action was triggered
      notCountAsInteraction = false;
    }
    if (label === undefined || label == null) {
      label = '';
    }
    if (value === undefined || value < 0) {
      value = 0;
    }

    if (window.dataLayer) {
      _trackActionGA(
        category,
        action,
        label,
        value,
        notCountAsInteraction,
        callback
      );
    } else {
      _trackActionLog(
        category,
        action,
        label,
        value,
        notCountAsInteraction,
        callback
      );
    }
  }

  function _trackSearch(searchText, productCategoryArray) {
    if (window.dataLayer) {
      _trachSearchGA(searchText, productCategoryArray);
    } else {
      _trackSearchLog(searchText, productCategoryArray);
    }
  }

  function _trackSearchLog(searchText, productCategoryArray) {
    console.log('search: ' + searchText + '\t' + productCategoryArray);
  }

  function _trachSearchGA(searchText, productCategoryArray) {
    if (window.dataLayer) {
      urlWithoutAnyParameters = location.pathname;
      searchTextParam = '?searchTextInternal=' + searchText;

      productCategoryParam = '';
      // only pass category parameter if we limit search to a single category
      if (
        productCategoryArray != null &&
        productCategoryArray.length != null &&
        productCategoryArray.length == 1
      ) {
        productCategoryParam = '&searchCatInternal=' + productCategoryArray[0];
      }
      completeUrl =
        urlWithoutAnyParameters + searchTextParam + productCategoryParam;
      window.dataLayer.push({
        event: 'trackPageView',
        customPath: completeUrl,
        uniqueIdDimension5: _getUniqueId(),
        uniqueIdDimension6: _getUniqueId(),
      });
    }
  }

  function _trackPageview() {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'trackPageView',
        uniqueIdDimension5: _getUniqueId(),
        uniqueIdDimension6: _getUniqueId(),
      });
    }
  }

  // write to console.log
  function _trackActionLog(
    category,
    action,
    label,
    value,
    notCountAsInteraction,
    callback
  ) {
    console.log(
      'clientSideAction: ' +
        category +
        '\t' +
        action +
        '\t' +
        label +
        '\t' +
        value +
        ' \t' +
        notCountAsInteraction
    );
  }

  function _trackActionGA(
    category,
    action,
    label,
    value,
    notCountAsInteraction,
    callback
  ) {
    callback = callback || function () {};

    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'trackAction',
        category: category,
        action: action,
        label: label,
        value: value,
        nonInteraction: notCountAsInteraction,
        eventCallback: callback,
        uniqueIdDimension5: _getUniqueId(),
        uniqueIdDimension6: _getUniqueId(),
      });
    }
  }

  return {
    trackAction: _trackAction,
    trackSearch: _trackSearch,
    startTimerForKey: _startTimerForKey,
    stopAndTrackTimerForKey: _stopAndTrackTimerForKey,
    trackTiming: _trackTiming,
    trackPageview: _trackPageview,
  };
})();

function trackingFunction(actionName, meta) {
  if (actionName == 'SEARCH_PRODUCT') {
    BV.tracking.trackAction(
      meta.userSells ? 'sell' : 'buy',
      'searchForProductAtLeastOnce',
      meta.productCategoryUuid == null ? '' : meta.productCategoryUuid,
      1
    );
    var productCategoryArray = new Array();
    if (meta.productCategoryUuid) {
      productCategoryArray.push(meta.productCategoryUuid);
    }
    BV.tracking.trackSearch(meta.searchText, productCategoryArray);
  } else if (actionName == 'SEARCH_PRODUCT_NO_PRODUCT_FOUND') {
    BV.tracking.trackAction(
      meta.userSells ? 'sell' : 'buy',
      'searchNoItemFound',
      meta.searchText,
      1,
      true
    );
  } else if (actionName == 'SELECT_PRODUCT_IN_SEARCH') {
    BV.tracking.trackAction(
      meta.userSells ? 'sell' : 'buy',
      'productSelection',
      meta.positionInResultList,
      1
    );
  } else if (actionName == 'PRICEQUERY_EXECUTE') {
    BV.tracking.trackAction(
      meta.userSells ? 'sell' : 'buy',
      'executePriceQuery',
      meta.product ? meta.product.get('externalId') : 'undefined',
      1
    );

    var productCategoryUuid =
      meta.product && meta.product.get('category')
        ? meta.product.get('category').get('uuid')
        : null;
    BV.tracking.trackAction(
      meta.userSells ? 'sell' : 'buy',
      'executePriceQueryForProductCategory',
      productCategoryUuid === null ? 'undefined' : productCategoryUuid,
      1
    );
  } else if (actionName == 'START_TRANSACTION') {
    BV.tracking.trackAction(
      meta.userSells ? 'sell' : 'buy',
      'startTransaction',
      meta.partner.get('name'),
      meta.offers.size
    );
    // keep legacy tracking event name 'partnerForward' around for some time, as the analytics scripts rely on it
    BV.tracking.trackAction(
      meta.userSells ? 'sell' : 'buy',
      'partnerForward',
      meta.partner.get('name'),
      meta.offers.size
    );

    // track number of different items per category

    if (meta.offers != null) {
      var categoryUuidsInOffers = meta.offers
        .map(function (offer) {
          return offer.get('category')
            ? offer.get('category').get('uuid')
            : null;
        })
        .filter(function (value, index, self) {
          return self.indexOf(value) === index;
        })
        .toJS();
      categoryUuidsInOffers.forEach(function (categoryUuid) {
        var countOffersForCategory = meta.offers.filter(function (offer) {
          return categoryUuid == null
            ? offer.get('category') == null
            : offer.get('category').get('uuid') === categoryUuid;
        }).size;
        BV.tracking.trackAction(
          meta.userSells ? 'sell' : 'buy',
          'startTransactionForProductCategory',
          categoryUuid === null ? 'undefined' : categoryUuid,
          countOffersForCategory
        );
        console.log(categoryUuid);
      });
    }
  } else if (actionName == 'CHANGE_TRANSACTION_STATE') {
    BV.tracking.trackAction(
      meta.userSells ? 'sell' : 'buy',
      'transactionChangedTo' + meta.nextTransactionState,
      meta.transactionBeforeChange.get('partner').get('name')
    );
  } else if (actionName == 'ATTEMPT_SIGNUP') {
    BV.tracking.trackAction('', 'registrationClick', meta.email, 1);
  } else if (actionName == 'SIGNUP_SUCCESS') {
    BV.tracking.trackAction('', 'registrationSuccess', meta.email, 1);
  } else if (actionName == 'SIGNUP_ERROR') {
    BV.tracking.trackAction('', 'registrationFail', meta.error.message, 1);
  } else if (actionName == 'ATTEMPT_LOGIN') {
    // no equivalent action right now
  } else if (actionName == 'LOGIN_SUCCESS') {
    BV.tracking.trackAction('', 'loginSuccess', meta.email, 1);
  } else if (actionName == 'LOGIN_ERROR') {
    BV.tracking.trackAction('', 'loginFail', meta.error.message, 1);
  } else if (actionName == 'PASSWORD_RESET_REQUEST_ATTEMPT') {
    //old event:BV.tracking.trackAction('', 'resetPasswordClick', meta.email, 1)
    BV.tracking.trackAction('', 'passwordRequestRequestAttempt', meta.email, 1);
  } else if (actionName == 'PASSWORD_RESET_REQUEST_SUCCESS') {
    BV.tracking.trackAction('', 'passwordRequestRequestSuccess', meta.email, 1);
  } else if (actionName == 'PASSWORD_RESET_REQUEST_ERROR') {
    BV.tracking.trackAction('', 'passwordRequestRequestError', meta.email, 1);
  } else if (actionName == 'REMOVE_ITEMS_FROM_CART') {
    BV.tracking.trackAction(
      meta.userSells ? 'sell' : 'buy',
      'removeItemsFromCart',
      '',
      meta.items.size
    );
  } else if (actionName == 'ADD_ITEMS_TO_CART') {
    BV.tracking.trackAction(
      meta.userSells ? 'sell' : 'buy',
      'addItemsToCart',
      '',
      meta.items.size
    );
  } else if (actionName == 'UPDATE_ITEMS_PRICE_IN_CART') {
    BV.tracking.trackAction(
      meta.userSells ? 'sell' : 'buy',
      'updateItemsPriceInCart',
      '',
      meta.items.size
    );
  } else if (actionName == 'SEARCH_ITEMS_IN_CART') {
    BV.tracking.trackAction(
      meta.userSells ? 'sell' : 'buy',
      'searchItemsInCart',
      meta.searchText
    );
  } else if (actionName == 'SORT_ITEMS_IN_CART') {
    BV.tracking.trackAction(
      meta.userSells ? 'sell' : 'buy',
      'sortItemsInCart',
      meta.sort.toLocaleString()
    );
  } else if (actionName == 'SELECT_ITEMS_IN_CART') {
    BV.tracking.trackAction(
      meta.userSells ? 'sell' : 'buy',
      'selectItemsInCart',
      '',
      meta.items.size
    );
  } else if (actionName == 'CHANGE_NUMBER_OF_VENDORS_IN_CART_RECOMMENDATION') {
    BV.tracking.trackAction(
      meta.userSells ? 'sell' : 'buy',
      'changeNumberOfVendorsInCartRecommendation',
      '',
      meta.numberOfVendors
    );
  } else if (actionName == 'CHANGE_DEAL_LIMITATIONS_IN_CART_RECOMMENDATION') {
    BV.tracking.trackAction(
      meta.userSells ? 'sell' : 'buy',
      'changeDealLimitationsInCartRecommendation',
      meta.considerDealLimitations ? 'true' : 'false'
    );
  } else if (actionName == 'CHANGE_VENDOR_FOR_ITEMS_IN_CART_RECOMMENDATION') {
    BV.tracking.trackAction(
      meta.userSells ? 'sell' : 'buy',
      'changeVendorForItemsInCartRecommendation',
      meta.offer.get('partner').get('name')
    );
  } else if (actionName == 'MASSINPUT_EXECUTE') {
    BV.tracking.trackAction(
      meta.userSells ? 'sell' : 'buy',
      'executeMassInput',
      '',
      meta.barcodes.size
    );
  } else if (actionName == 'CHANGE_PERSONAL_INFORMATION') {
    BV.tracking.trackAction(
      meta.userSells ? 'sell' : 'buy',
      'changePersonalInformation'
    );
  } else if (actionName == 'CHANGE_PREFERRED_PARTNERS') {
    BV.tracking.trackAction(
      meta.userSells ? 'sell' : 'buy',
      'changePreferredPartners'
    );
  } else if (actionName == 'CHANGE_PASSWORD') {
    BV.tracking.trackAction(meta.userSells ? 'sell' : 'buy', 'changePassword');
  } else {
    console.log('unmapped action ' + actionName);
  }
};`;

export const addUserInfosToGTM = `function addUserInfosToGTM(user) {
    if (window.dataLayer) {
      window.dataLayer.push({
        userUuid: user == null ? null : user.get('uuid'),
        userValidated: user != null && user.get('validated'),
      });
    }
  }`;
